<template>
  <!-- 话务管理-录音收藏 -->
  <basic-container>
    <avue-crud
      ref="crud"
      :option="tableOption"
      :table-loading="loading"
      :data="tableData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="loadData"
      @on-load="loadData"
    >
      <template slot="menuLeft">
        <AudioBar v-if="audioInfo" :audioInfo="audioInfo"></AudioBar>
      </template>
      <template slot-scope="{ row }" slot="menu">
        <el-button
          v-if="permissionList.collectionBtn"
          type="text"
          size="small"
          @click="delCollection(row)"
        >
          取消收藏
        </el-button>
      </template>
      <template slot="dateRangeSearch">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 100%"
        >
        </el-date-picker>
      </template>
      <template slot="radio" slot-scope="{ row }">
        <el-radio v-model="selectRowIndex" :label="row.$index" @change="rowClick(row)">
          <span>{{ '' }}</span>
        </el-radio>
      </template>
      <template slot="duration" slot-scope="{ row }">
        <span> {{ secondsToDuration(row.duration, 'chi') }} </span>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import AudioBar from '../../components/audio-bar';
import { mapGetters } from 'vuex';
import { getProjectListApi } from '@/api/call-system/index';
import {
  getCollectionPageListApi as getPageListApi,
  collectionApi,
} from '@/api/call-system/call-manage/recording-manage';
import { secondsToDuration } from '../../common';

export default {
  components: {
    AudioBar,
  },
  data() {
    return {
      isPageCache: false, // 当前页面是否从后台直接显示的 true-从后台直接显示的，也就是页面是缓存状态 false-重新加载的
      oldProjectId: '', // 旧项目id，重置搜索条件和新增时需要使用
      projectList: [], // 项目列表
      dialogType: '', // 弹框的类型
      dialogTitle: '', // 弹框显示的标题
      isDialogShow: false, // 弹框是否显示着
      needCloseConfirm: false, // 关闭弹框时是否需要确认弹框，该值是根据场景动态调整的
      searchForm: {}, // 搜索条件
      dateRange: [], // 搜索条件-起止日期
      selectRowIndex: -1, // 选中的行在当前页的序号
      audioInfo: null, // 选中的行对应的数据
      loading: false, // 是否正在加载表格数据
      tableData: [], // 表格数据
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格显示的配置项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        dialogClickModal: false,
        searchMenuSpan: 24,
        searchLabelWidth: 100,
        menuWidth: 160,
        column: [
          {
            label: '选择',
            prop: 'radio',
            width: 50,
            slot: true,
          },
          {
            label: '项目名称',
            prop: 'projectId',
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
            },
            type: 'select',
            hide: true,
            showColumn: false,
            display: false,
            // search: true,
            // searchClearable: false,
          },
          {
            label: '收藏日期',
            prop: 'dateRange',
            display: false,
            showColumn: false,
            search: true,
            searchslot: true,
            searchSpan: 12,
          },
          {
            label: '标题',
            prop: 'title',
          },
          {
            label: '坐席工号',
            prop: 'serviceNo',
          },
          {
            label: '坐席姓名',
            prop: 'serviceName',
          },
          {
            label: '主叫号码',
            prop: 'fromPhone',
            search: true,
            maxlength: 13,
          },
          {
            label: '被叫号码',
            prop: 'toPhone',
            search: true,
            maxlength: 13,
          },
          {
            label: '通话时间',
            prop: 'duration',
            slot: true,
          },
          {
            label: '收藏时间',
            prop: 'addTime',
          },
          {
            label: '备注',
            prop: 'description',
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        collectionBtn: this.vaildData(
          this.permission.callSystem_callManage_recordingCollection_cancel,
          false
        ),
      };
    },
  },
  created() {
    getProjectListApi().then(({ data }) => {
      this.projectList = data || [];
      if (this.projectList.length > 0) {
        this.findObject(this.tableOption.column, 'projectId').dicData = this.projectList;
        this.searchForm.projectId = this.projectList[0].id;
        this.loadData();
      }
    });
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 从缓存状态恢复窗口显示时重新请求下数据
    if (this.isPageCache) {
      this.loadData();
    }
    this.isPageCache = true;
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    secondsToDuration: secondsToDuration,
    /* 调整视图区域 */
    ajustView() {
      const tableInitH = this.bodyHeight - 395; // 表格区域初始化高度
      const searchH = 116; // 搜索区域占的高度
      this.tableOption.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.tableOption.height == tableInitH) {
              this.tableOption.height = tableInitH + searchH;
            } else {
              this.tableOption.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    /* 加载表格数据 */
    loadData(page) {
      if (!this.searchForm.projectId) return;
      this.oldProjectId = this.searchForm.projectId;
      page = page || this.tablePage;
      this.loading = true;
      getPageListApi(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.searchForm)
      ).then(({ data }) => {
        this.tablePage.total = data.total;
        this.tableData = data.records;
        this.selectRowIndex = -1;
        this.loading = false;
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.selectRowIndex = -1;
      this.dateRange = [];
      this.searchForm = {
        projectId: this.oldProjectId,
      };
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.selectRowIndex = -1;
      this.searchForm = params;
      this.dealDateRange();
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    /* 转化日期范围 */
    dealDateRange() {
      if (this.dateRange && this.dateRange.length > 0) {
        this.searchForm.addTimeBegin = this.dayjs(this.dateRange[0]).format('YYYY-MM-DD 00:00:00');
        this.searchForm.addTimeEnd = this.dayjs(this.dateRange[1]).format('YYYY-MM-DD 23:59:59');
      } else {
        this.searchForm.addTimeBegin = '';
        this.searchForm.addTimeEnd = '';
        this.dateRange = [];
      }
    },
    /* 行点击 */
    rowClick(row) {
      this.selectRowIndex = row.$index;
      this.audioInfo = this.tableData[this.selectRowIndex];
    },
    /* 取消收藏 */
    delCollection(row) {
      collectionApi({
        id: row.id,
        favoriteFlag: 0,
      }).then(() => {
        this.$message.success('操作成功!');
        this.loadData();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
